import instance from "@/services/api";

export const bufferParamsAPI = {
  async getList(params) {
    return await instance()
      .get("/floor_map/floor_buffer/read/", { params })
      .then((res) => res?.data);
  },
  async deleteParam(body, params) {
    return await instance()
      .post(`/floor_map/floor_buffer/delete/`, body, { params })
      .then((res) => res?.data);
  },
};
